import styled from 'styled-components'

import RecipeCardList from '../RecipeCardList'
import RecipesFilters from '../RecipesFilters'
import { mq, sizes } from '../../theme'

export const Inner = styled.section`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  padding-top: 1.5rem;
`

export const Anchor = styled.div`
  margin-top: -10rem;
  position: absolute;
  @media ${mq(sizes.tablet)} {
    margin-top: -15rem;
  }
  @media ${mq(sizes.desktop)} {
    margin-top: -18rem;
  }
`

export const Filters = styled(RecipesFilters)`
  margin-bottom: 2rem;
`
export const CardList = styled(RecipeCardList)``
